"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsContact = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-curly-newline */
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const InputText_1 = require("../InputText");
const Modal_1 = require("../Modal");
const className_1 = require("../../utils/className");
exports.SmlsContact = ({ idPhoneNumber = '', isValidPhoneNumber, listCountries, forceError = false, headerTitle, idSearchDDI = '', idFlag = '', idErrorMsg = '', defaultCountryISO = 'BR', textLabel, className = '', notFoundMessage = 'Não encontramos nenhum resultado. Tente novamente', errorMessage, errorMessageDDD, onChange = () => undefined, onFocus, onBlur, isValid = () => undefined, defaultValue = '', maxLength = 19, value, placeHolder, }) => {
    const [isOpen, setIsOpen] = react_1.useState(false);
    const [countries, setCountries] = react_1.useState(listCountries);
    const [isFocused, setIsFocused] = react_1.useState(false);
    const [innerValue, setInnerValue] = react_1.useState('');
    const [isValidNumber, setIsValidNumber] = react_1.useState(false);
    const [countryISO2, setCountryISO2] = react_1.useState(defaultCountryISO);
    const [errorDDD, setErrorDDD] = react_1.useState(false);
    const [ddiSearchTerm, setDdiSearchTerm] = react_1.useState('');
    const [showFixedHeader, setShowFixedHeader] = react_1.useState(false);
    const enableOutline = react_1.useCallback(() => {
        if (onFocus)
            onFocus();
        setIsFocused(true);
    }, [onFocus]);
    const disableOutline = react_1.useCallback(() => {
        if (onBlur)
            onBlur();
        setIsFocused(false);
    }, []);
    const modalContentRef = react_1.useRef(null);
    const inputRef = react_1.useRef(null);
    react_1.useEffect(() => {
        var _a;
        if (!countries)
            return;
        const DDI = ((_a = countries.find((country) => country.iso2 === countryISO2)) === null || _a === void 0 ? void 0 : _a.ddi) || '';
        if (innerValue.split(' ')[1])
            return;
        setInnerValue(`+${DDI}`);
    }, [countryISO2]);
    react_1.useEffect(() => {
        setCountries(listCountries);
    }, [listCountries]);
    react_1.useEffect(() => {
        onChange(innerValue);
        isValid(isValidNumber);
    }, [isValidNumber, innerValue]);
    const handleFormat = react_1.useCallback((phone) => {
        let newPhone = phone;
        if (newPhone.match(/[^0-9-_ ()+]+/gi) || newPhone.length > 19)
            return;
        if (phone[0] !== '+' && phone.length >= 1) {
            const foundIso = countries.find((country) => country.iso2 === countryISO2);
            newPhone = `+${foundIso.ddi}${phone}`;
        }
        setInnerValue(newPhone);
        try {
            const { isValid: isValidPhone, DDD, DDI, nationalNumber, } = isValidPhoneNumber(newPhone);
            if ((DDI === null || DDI === void 0 ? void 0 : DDI.country) === 'BR') {
                const isValidDDD = Boolean(DDD === null || DDD === void 0 ? void 0 : DDD.isValid);
                setIsValidNumber(isValidPhone && isValidDDD);
                setErrorDDD(!isValidDDD);
            }
            else {
                setErrorDDD(false);
                setIsValidNumber(isValidPhone);
            }
            if (DDI === null || DDI === void 0 ? void 0 : DDI.country)
                setCountryISO2(DDI.country);
            if (nationalNumber && (DDI === null || DDI === void 0 ? void 0 : DDI.value))
                setInnerValue(`+${DDI === null || DDI === void 0 ? void 0 : DDI.value} ${nationalNumber}`);
        }
        catch (error) {
            setIsValidNumber(false);
        }
    }, [isValidPhoneNumber]);
    const handleChangeInput = react_1.useCallback((e) => {
        const phone = e.target.value;
        handleFormat(phone);
    }, [countryISO2, countries, isValidPhoneNumber]);
    const handleSearchChange = react_1.useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        const text = e.target.value;
        const exp = new RegExp(text, 'ig');
        const filtered = listCountries.filter((country) => country.country.match(exp));
        setCountries(filtered);
        setDdiSearchTerm(text);
    }), [listCountries]);
    const handleDdiSelected = react_1.useCallback((country) => {
        if (countryISO2 !== country) {
            setInnerValue('');
            setCountryISO2(country);
            setIsValidNumber(false);
        }
        setIsOpen(false);
        setCountries(listCountries);
    }, [countryISO2, listCountries]);
    const handleOnModalClosed = react_1.useCallback(() => {
        setIsOpen(false);
        setDdiSearchTerm('');
        setCountries(listCountries);
    }, []);
    const handleScroll = react_1.useCallback(() => {
        const countriesLength = countries.length || 0;
        if (!modalContentRef.current)
            return;
        if (window.innerHeight / 80 > countriesLength) {
            setShowFixedHeader(false);
            return;
        }
        setShowFixedHeader(modalContentRef.current.getBoundingClientRect().y < -76);
    }, [countries]);
    react_1.useEffect(() => {
        var _a;
        (_a = document
            .querySelector('.contact-modal > div > div > .modal-body')) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', handleScroll);
        return () => { var _a; return (_a = document
            .querySelector('.contact-modal > div > div > .modal-body')) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', handleScroll); };
    }, [handleScroll]);
    react_1.useEffect(() => {
        var _a;
        if (!showFixedHeader) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [showFixedHeader]);
    react_1.useEffect(() => {
        if (defaultValue && !(value === null || value === void 0 ? void 0 : value.length)) {
            try {
                const { isValid: isValidPhone, DDI, nationalNumber, } = isValidPhoneNumber(defaultValue);
                if (isValidPhone) {
                    setInnerValue(`+${DDI === null || DDI === void 0 ? void 0 : DDI.value} ${nationalNumber}`);
                    setErrorDDD(false);
                    setIsValidNumber(isValidPhone);
                }
            }
            catch (error) {
                //
            }
        }
    }, [isValidPhoneNumber]);
    react_1.useEffect(() => {
        if (value === null || value === void 0 ? void 0 : value.length) {
            handleFormat(value || '');
        }
    }, [value]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: className_1.mapToCssModules([
                'input-group',
                'input-contact',
                isFocused ? 'input-outline' : '',
                forceError ||
                    (errorMessage && !isValidNumber && innerValue.length >= 7)
                    ? 'error'
                    : '',
                className,
            ]) },
            react_1.default.createElement("label", { htmlFor: "input-text" }, textLabel),
            react_1.default.createElement("div", null,
                react_1.default.createElement("i", { id: idFlag, onClick: () => {
                        setIsOpen((prevState) => !prevState);
                    }, className: `smls-flags ${countryISO2.toLowerCase()}` }),
                react_1.default.createElement("input", { id: idPhoneNumber, value: innerValue, onChange: handleChangeInput, onFocus: enableOutline, onBlur: disableOutline, defaultValue: defaultValue, maxLength: maxLength, placeholder: placeHolder })),
            react_1.default.createElement("div", { id: idErrorMsg, className: "input-error" }, forceError ||
                (errorMessage && !isValidNumber && innerValue.length >= 7) ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("i", { className: "material-icons" }, "error_outline"),
                react_1.default.createElement("label", { htmlFor: "input-text" }, errorDDD ? errorMessageDDD : errorMessage))) : (react_1.default.createElement(react_1.default.Fragment, null)))),
        react_1.default.createElement(Modal_1.SmlsModal, { isOpen: isOpen, onClosed: handleOnModalClosed, type: "right", className: "contact-modal", toggle: () => setIsOpen(false), defaultHeader: !showFixedHeader },
            showFixedHeader && (react_1.default.createElement("div", { className: "fixed-modal-header" },
                react_1.default.createElement(InputText_1.SmlsInputText, { id: idSearchDDI, placeholder: "Buscar seu pa\u00EDs", value: ddiSearchTerm, onChange: handleSearchChange, regex: /[^0-9A-Za-záàâãéèêíïóôõöúüçñÁÀÂÃÉÈÍÏÓÔÕÖÚÜÇÑ .]+/g, maxLength: maxLength }),
                react_1.default.createElement("button", { type: "button", className: "smls-btn-close", "data-dismiss": "modal", "aria-label": "Close", onClick: () => setIsOpen(false) },
                    react_1.default.createElement("i", { className: "material-icons" }, "close")))),
            react_1.default.createElement(reactstrap_1.ModalBody, null,
                react_1.default.createElement("div", { ref: modalContentRef },
                    headerTitle && react_1.default.createElement("h3", null, headerTitle),
                    react_1.default.createElement(InputText_1.SmlsInputText, { id: idSearchDDI, placeholder: "Buscar seu pa\u00EDs", value: ddiSearchTerm, onChange: handleSearchChange, icon: react_1.default.createElement("i", { className: "material-icons" }, "search"), innerRef: inputRef, regex: /[^0-9A-Za-záàâãéèêíïóôõöúüçñÁÀÂÃÉÈÍÏÓÔÕÖÚÜÇÑ .]+/g, maxLength: maxLength }),
                    react_1.default.createElement(reactstrap_1.ListGroup, null, countries === null || countries === void 0 ? void 0 : countries.map((country) => (react_1.default.createElement("li", { className: "list-group-item", id: `opt_${country.iso2}`, key: country.iso2, onClick: () => handleDdiSelected(country.iso2) },
                        react_1.default.createElement("i", { className: `smls-flags ${country.iso2.toLowerCase()}` }),
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("b", null, `+${country.ddi}`),
                            ` ${country.country}`)))))),
                (!countries || !countries.length) && (react_1.default.createElement("div", { className: "country-not-found" },
                    react_1.default.createElement("p", null, notFoundMessage)))))));
};
//# sourceMappingURL=index.js.map